import { render } from "./StockTransaction.vue?vue&type=template&id=17124383&scoped=true&ts=true"
import script from "./StockTransaction.vue?vue&type=script&lang=ts"
export * from "./StockTransaction.vue?vue&type=script&lang=ts"

import "./StockTransaction.vue?vue&type=style&index=0&id=17124383&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17124383"]])

export default __exports__